import { useI18n } from 'vue-i18n';
import {
  formatMessageStamp,
  formatMessageTimestamp,
  formatDateTime,
  formatDateOnly,
  formatNumericDate,
  formatRelativeTime,
  formatDateWith,
} from 'shared/helpers/dateTimeFormatter';

/**
 * Locale-aware replacement for the raw helpers in shared/helpers/timeHelper.js
 * and shared/helpers/DateHelper.js. Reads the active locale from vue-i18n and
 * applies it to every formatted value.
 */
export function useLocalizedTime() {
  const { locale } = useI18n();

  return {
    messageStamp: time => formatMessageStamp(time, locale.value),
    messageTimestamp: time => formatMessageTimestamp(time, locale.value),
    dateTime: time => formatDateTime(time, locale.value),
    dateOnly: time => formatDateOnly(time, locale.value),
    numericDate: time => formatNumericDate(time, locale.value),
    relativeTime: time => formatRelativeTime(time, locale.value),
    formatWith: (date, options) => formatDateWith(date, locale.value, options),
  };
}
